import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from '../context/auth/hooks';
import { identifyLDUser } from '../utilities/identifyLDUser';

export const LDUserLocation = () => {
  const location = useLocation();
  const client = useLDClient();
  const { isLoggedIn } = useAuth();

  // update LaunchDarkly user attributes when location changes
  useEffect(() => {
    if (client) {
      identifyLDUser(client, isLoggedIn);
    }
  }, [client, location, isLoggedIn]);

  return null;
};
